/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Public_TitleInputs */

const en_directory_api_reference_public_title = /** @type {(inputs: Directory_Api_Reference_Public_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public directory endpoints`)
};

const zh_directory_api_reference_public_title = /** @type {(inputs: Directory_Api_Reference_Public_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公开目录端点`)
};

/**
* | output |
* | --- |
* | "Public directory endpoints" |
*
* @param {Directory_Api_Reference_Public_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_public_title = /** @type {((inputs?: Directory_Api_Reference_Public_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Public_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_public_title(inputs)
	return zh_directory_api_reference_public_title(inputs)
});
export { directory_api_reference_public_title as "directory.api_reference.public_title" }